import {gql} from '@apollo/client';

export const CURRENT_USER_ACTIVE_SUBSCRIPTION = gql`
    subscription CurrentUserActiveSubscription($email: String!, $sessionId: String!) {
        user: users(where: {email: {_eq: $email}, last_session_id: {_eq: $sessionId}}, limit: 1) {
            uuid
        }
    }
`;